<template>
  <section class="container z-grid v-page-section-container-padding mb-8 md:mb-12">
    <div class="relative z-10 z-grid__cols z-grid__content py-6 bg-white rounded-3xl">
      <h3 v-if="label" class="text-xl sm:text-2xl leading-tight mb-6 lg:mb-8 text-current">{{ label }}</h3>
      <AtomNewsletter :url="url" :endpoint-path="endpointPath" :origin="origin" />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  label: { type: String, required: false, default: undefined },
  origin: { type: String, required: false, default: undefined },
  endpointPath: { type: String, required: false, default: undefined },
  url: { type: String, required: true },
})
</script>
